export const setdeletePublic = () => ({
    type: 'SET_DELETE',
});